import React, { useEffect } from "react";
import { connect } from "react-redux";
import { getRoles, resetRoles } from "./actions/roles.actions";
import { CardBody, Alert, Spinner, Col } from "reactstrap";
import { Link } from "react-router-dom";
import { MdRefresh } from "react-icons/md";
import { permissionsConstants } from "../../constants/permission.constants";
import { MdArrowForward } from "react-icons/md";

const RolesCard = (props) => {
    const { roles, dispatch, permissions, currentUser } = props;
    let userPermissions = permissions && permissions.response;

    userPermissions = userPermissions && userPermissions.map((permission) => permission.authority);

    const isAdmin = userPermissions && userPermissions.includes(permissionsConstants.ASSIGN_USER_ROLE);

    const domainCode = isAdmin ? "" : currentUser && currentUser.response && currentUser.response.domainCode;

    const fetchRoles = () => {
        dispatch(getRoles(domainCode));
    };
    useEffect(() => {
        const fetchRoles = () => {
            dispatch(getRoles(domainCode));
        };
        if (!isAdmin) {
            fetchRoles();
        }
        return () => dispatch(resetRoles());
    }, [dispatch, domainCode, isAdmin]);

    return (
        <CardBody>
            <div className="card__title" style={{ display: "flex", justifyContent: "space-between" }}>
                <h5 className="bold-text">AVAILABLE ROLES</h5>
                <h5 className="bold-text float-right">
                    <Link to="/roles" id="link-all-users">
                        See all roles <MdArrowForward size={20} />
                    </Link>
                </h5>
            </div>
            {roles.loading ? (
                <Col md={12} style={{ padding: "0", textAlign: "center" }}>
                    <Spinner className="text-center" size="md" color="danger" />
                </Col>
            ) : (
                <div className="rolesCard-container">
                    {roles && roles.response && roles.response.data ? (
                        roles.response.data.map((role, index) => {
                            if (index < 4) {
                                return (
                                    <div className="rolesCard" key={index}>
                                        <h5>{role.name}</h5>
                                        <br />
                                        {/* <h5 className="bold-text mt-4">
                        <Link to="/roles" id="link-all-users">
                            See more details <MdArrowForward size={20} /> 
                        </Link>
                        </h5> */}
                                    </div>
                                );
                            }
                        })
                    ) : roles && roles.error ? (
                        <Col md={12} style={{ padding: "0" }}>
                            <Alert color="danger">
                                Could not fetch roles
                                {roles.loading ? <Spinner className="float-right" size="sm" color="danger" /> : <MdRefresh onClick={fetchRoles} className="float-right pointer" size={20} />}
                            </Alert>
                        </Col>
                    ) : null}
                </div>
            )}
        </CardBody>
    );
};

export default connect((state) => ({
    roles: state.roles,
    permissions: state.permissions,
    currentUser: state.currentUser,
}))(RolesCard);
